import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--media-hub-drawer"
export default class extends Controller {
  static targets = ["drawer", "backdrop", "frame"]

  connect() {
    this.handleFrameLoad = this.open.bind(this)
    this.handleFrameFetch = this.open.bind(this)
    this.handleEscapeKey = this.closeOnEscape.bind(this)

    if (this.hasFrameTarget) {
      this.frameTarget.addEventListener("turbo:before-fetch-request", this.handleFrameFetch)
      this.frameTarget.addEventListener("turbo:frame-load", this.handleFrameLoad)
    }

    document.addEventListener("keydown", this.handleEscapeKey)
  }

  disconnect() {
    if (this.hasFrameTarget) {
      if (this.handleFrameFetch) this.frameTarget.removeEventListener("turbo:before-fetch-request", this.handleFrameFetch)
      if (this.handleFrameLoad) this.frameTarget.removeEventListener("turbo:frame-load", this.handleFrameLoad)
    }
    if (this.handleEscapeKey) document.removeEventListener("keydown", this.handleEscapeKey)
    document.body.classList.remove("overflow-hidden")
  }

  openFromLink() {
    this.open()
  }

  open() {
    if (this.hasBackdropTarget) this.backdropTarget.classList.remove("hidden")
    if (this.hasDrawerTarget) this.drawerTarget.classList.remove("translate-x-full")
    this.updateBodyScrollLock()
  }

  close() {
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("hidden")
    if (this.hasDrawerTarget) this.drawerTarget.classList.add("translate-x-full")
    this.updateBodyScrollLock()
  }

  closeOnBackdrop(event) {
    if (!this.hasBackdropTarget) return
    if (event.target === this.backdropTarget) this.close()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    if (this.drawerOpen()) this.close()
  }

  handleSubmitEnd(event) {
    if (!event.detail.success) return
    if (!this.hasFrameTarget) return

    const submittedForm = event.target
    if (submittedForm instanceof HTMLFormElement && this.frameTarget.contains(submittedForm)) {
      this.close()
      this.frameTarget.removeAttribute("src")
    }
  }

  drawerOpen() {
    return this.hasDrawerTarget && !this.drawerTarget.classList.contains("translate-x-full")
  }

  updateBodyScrollLock() {
    if (this.drawerOpen()) {
      document.body.classList.add("overflow-hidden")
    } else {
      document.body.classList.remove("overflow-hidden")
    }
  }
}
